var $ = require('jquery');

$(document).ready(function() {
if(/MSIE \d|Trident.*rv:/.test(navigator.userAgent) === false) {
  return;
}
  let headingClasses = ['title__title--h1', 'title__title--h2', 'title__title--h3', 'list__title', 'page-header__title', 'side-box__title', 'quote__quote', 'list__header', 'list__title']
  let subtitleClasses = ['page-header__subtitle']
  let textClasses = ['list__text', 'summary__text', 'editor p', 'text__content ul', 'text__content ol']

  let borderBottomClass = ['quote__quote']
  let borderTopClass = [ 'quote__quote']

  let frameClasses = ['list--frame', 'hero--background-default', 'contact--type-default', 'gallery--default', 'footer', 'fullsize_banner--background-default', 'text--frame']
  let gradientClasses = ['contact--type-gradient_map', 'banner__content', 'hero--background-graphic', 'hero--background-gradient', 'gallery--gradient', 'fullsize_banner--background-graphic']

  let buttonPrimaryClasses = ['button--primary']
  let buttonSecondaryClasses = ['button--secondary']
  let buttonLightClasses = ['button--light']
  let buttonGhostClasses = ['button--ghost']

  document.styleSheets[0].addRule('.page-header--gradient-site::after', 'background: linear-gradient(to right, '+window.cssVars.secondaryColor+' 0%, '+window.cssVars.primaryColor+' 100%); opacity: 0.9');

  document.styleSheets[0].addRule('.menu li:hover ul', 'background-color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.menu li:hover', 'background-color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.menu > li:hover', 'border-top: 2px solid '+window.cssVars.secondaryColor)
  document.styleSheets[0].addRule('.menu > li:hover', 'border-bottom: 1px solid '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.menu > li.menu-item-has-children:hover', 'border-top: 2px solid '+window.cssVars.secondaryColor)
  document.styleSheets[0].addRule('.menu > li.menu-item-has-children:hover', 'border-bottom: 1px solid '+window.cssVars.secondaryColor)
  document.styleSheets[0].addRule('.menu > li a:link', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.menu > li a:visited', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.menu > li a:active', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.menu li a:active', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.menu li:hover a', 'color: #fff')

  document.styleSheets[0].addRule('.editor a', 'color: '+window.cssVars.primaryColor)

  document.styleSheets[0].addRule('.search__input', 'background: '+window.cssVars.frameColor)

  document.styleSheets[0].addRule('.socials__wrapper', 'border-top: 1px solid'+window.cssVars.secondaryColor)

  document.styleSheets[0].addRule('.text__content h2', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.text__content h3', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.text__content h1', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.text__content ol', 'color: '+window.cssVars.primaryColor)

  document.styleSheets[0].addRule('.aside .side-box', 'background: '+window.cssVars.frameColor)

  document.styleSheets[0].addRule('.side-box__box-title a', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.side-box__title', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.side-box__box-title', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.side-box__figure', 'height: 280px')

  document.styleSheets[0].addRule('.footer__copyright', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.breadcrumbs a', 'color: '+window.cssVars.secondaryColor)

  document.styleSheets[0].addRule('.link', 'color: '+window.cssVars.primaryColor)

  document.styleSheets[0].addRule('.gallery__title', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.gallery--gradient .gallery__title', 'color: #fff')

  document.styleSheets[0].addRule('.hero--background-graphic .hero__text', 'color: #fff')
  document.styleSheets[0].addRule('.hero--background-gradient .hero__text', 'color: #fff')
  document.styleSheets[0].addRule('.hero--background-default .hero__text', 'color: '+window.cssVars.primaryColor)

  document.styleSheets[0].addRule('.hero--background-graphic .hero__title', 'color: #fff')
  document.styleSheets[0].addRule('.hero--background-gradient .hero__title', 'color: #fff')
  document.styleSheets[0].addRule('.hero--background-default .hero__title', 'color: '+window.cssVars.primaryColor)

  document.styleSheets[0].addRule('.contact--type-gradient_map .map__title', 'color: #fff')
  document.styleSheets[0].addRule('.contact--type-default .map__title', 'color: '+window.cssVars.primaryColor)

  document.styleSheets[0].addRule('.contact__image', 'min-height: 600px' )
  document.styleSheets[0].addRule('.contact__pin', 'display: none' )

  document.styleSheets[0].addRule('.image__figure', 'max-width: 100%' )
  document.styleSheets[0].addRule('.image__caption', 'display: none' )
  document.styleSheets[0].addRule('.image--mask-curved .image__figure::before', 'display: none' )
  document.styleSheets[0].addRule('.image__figure', 'min-height: 400px')
  document.styleSheets[0].addRule('.image__figure', 'background-position-x: center !important')
  document.styleSheets[0].addRule('.image__figure', 'background: none')

  document.styleSheets[0].addRule('.image__figure::before', 'right: 0px !important')
  document.styleSheets[0].addRule('.image__figure::before', 'display: block !important')

  document.styleSheets[0].addRule('.image--two-columns .image__figure', 'width: 48% !important')
  document.styleSheets[0].addRule('.image--two-columns .image__figure', 'right: -10px')


  document.styleSheets[0].addRule('.page-header__figure', 'background-position-y: center!important')
  document.styleSheets[0].addRule('.page-header__figure', 'background-position-x: center!important')
  document.styleSheets[0].addRule('.page-header', 'display: block !important;'  )
  document.styleSheets[0].addRule('.page-header__wrapper', 'height: 100%;')
  document.styleSheets[0].addRule('.page-header__wrapper', 'align-items: flex-end')
  document.styleSheets[0].addRule('.page-header__text', 'color: '+window.cssVars.textColor)

  document.styleSheets[0].addRule('.fullsize_banner__title', 'color: '+window.cssVars.primaryColor)

  document.styleSheets[0].addRule('.list--frame .list__wrapper__title', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.list__wrapper__title', 'color: '+window.cssVars.primaryColor)
  document.styleSheets[0].addRule('.list__image--related::before', 'background: linear-gradient(to right, '+window.cssVars.secondaryColor+' 0%, '+window.cssVars.primaryColor+' 100%); opacity: 0.6');


  document.styleSheets[0].addRule('.button--primary', 'background: linear-gradient(to right, '+window.cssVars.secondaryColor+' 0%, '+window.cssVars.primaryColor+' 100%); opacity: 0.6');



  $('.rewrite-css-vars').each(function() {
      let $el = $(this);

      headingClasses.forEach(function(headingClass){

        if ($el.hasClass(headingClass)) {
          $el.css({
            'font-family': window.cssVars.headerFont,
            'color': window.cssVars.headerColor,
          })
        }
      });

      gradientClasses.forEach(function(gradientClass){

        if ($el.hasClass(gradientClass)) {
          $el.css({
            'background': 'linear-gradient(to right, '+window.cssVars.secondaryColor+' 0%, '+window.cssVars.primaryColor+' 100%)',
            'color': window.cssVars.headerColor,
          })
        }
      });

      borderTopClass.forEach(function(borderTopClass){

        if ($el.hasClass(borderTopClass)) {
          $el.css({
            'border-top': '1px solid ' +window.cssVars.frameColor,
          })
        }
      });

      borderBottomClass.forEach(function(borderTopClass){

        if ($el.hasClass(borderTopClass)) {
          $el.css({
            'border-bottom': '1px solid ' +window.cssVars.frameColor,
          })
        }
      });


      textClasses.forEach(function(textClasses){

        if ($el.hasClass(textClasses)) {
          $el.css({
            'color': window.cssVars.textColor,
          })
        }
      });

      subtitleClasses.forEach(function(subtitleClasses){

        if ($el.hasClass(subtitleClasses)) {
          $el.css({
            'color': window.cssVars.textColor,
          })
        }
      });

      frameClasses.forEach(function(frameClasses){

        if ($el.hasClass(frameClasses)) {
          $el.css({
            'background': window.cssVars.frameColor,
          })
        }
      });



      buttonPrimaryClasses.forEach(function(buttonPrimaryClasses){

        if ($el.hasClass(buttonPrimaryClasses)) {
          $el.css({
            'background': 'linear-gradient(to right, '+window.cssVars.secondaryColor+' 0%, '+window.cssVars.primaryColor+' 100%)',
          })
        }
      });

      buttonSecondaryClasses.forEach(function(buttonSecondaryClasses){

        if ($el.hasClass(buttonSecondaryClasses)) {
          $el.css({
            'color': window.cssVars.primaryColor,
            'background': window.cssVars.frameColor,
          })
        }
      });

      buttonGhostClasses.forEach(function(buttonGhostClasses){

        if ($el.hasClass(buttonGhostClasses)) {
          $el.css({
            'color': window.cssVars.primaryColor,
          })
        }
      });

      buttonLightClasses.forEach(function(buttonLightClasses){

        if ($el.hasClass(buttonLightClasses)) {
          $el.css({
            'color': '#fff',
          })
        }
      });

  });

  checkBrowser();

});

function checkBrowser() {
  if('objectFit' in document.documentElement.style === false) {
    $('img.polyfill-object-fit-cover').each(function() {
      var $this = $(this);

      if('objectFit' in $this[0].style === false) {
        var source = $this.attr("src");
        var parent = $this.parent();

        parent.css("background", "url(" + source + ")");
        parent.css("background-size", "cover");
        $this.css("display", "none");
      }

      else {
      //  var source = $this.attr("src");
      //  var parent = $this.parent();

        parent.css("background", "url(" + source + ")");
        parent.css("background-size", "cover");
        parent.css("background-position", "center center");
        $this.css("display", "none");
      }

    });
  }
}
